import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import { IRole } from 'interfaces/roles'
import { Courses as CountLink } from '../accessToCourses/styled'
import Detail from './detail/index'

interface IProps {
  role: IRole
}

const AssignedUsers = ({ role }: IProps) => {
  const { t } = useTranslation()
  const countLabel = 'configuration.rolesAndPermissions.users.table'
  const [open, setOpen] = useState(false)
  const count = role.users

  return (
    <>
      <CountLink onClick={() => setOpen(true)}>
        {count.toLocaleString('en-US')}{' '}
        {count === 1
          ? t(`${countLabel}.rowsCountV2`)
          : t(`${countLabel}.rowsCount_pluralV2`)}
        <FontAwesomeIcon icon={faEye} />
      </CountLink>
      {open && <Detail role={role} close={() => setOpen(false)} />}
    </>
  )
}

export default AssignedUsers
